import React from 'react'
import classNames from 'classnames'
import s from './SearchDialog.less'
import SlideInOut from '../animation/SlideInOut'
import { isUIElementDisplayed } from '../../store/ui/ui.selectors'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { useSelector } from 'react-redux'

const SearchDialog = ({ children, suggestContent }) => {
  const searchDialogIsDisplayed = useSelector(isUIElementDisplayed(UI_ELEMENTS.SEARCH_DIALOG))
  const suggestIsDisplayed = useSelector(isUIElementDisplayed(UI_ELEMENTS.SUGGEST))

  return (
    <SlideInOut display={searchDialogIsDisplayed}>
      {animationState => (
        <dialog className={classNames(s.SearchDialog, searchDialogIsDisplayed && s.SearchDialog_displayed)}>
          <div className={s.SearchDialog_scrollableContent}>
            {(animationState === 'exiting' || suggestIsDisplayed) && suggestContent}
            {!suggestIsDisplayed && children}
          </div>
        </dialog>
      )}
    </SlideInOut>
  )
}

export default SearchDialog
